import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'dict' })
export class DictionaryPipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        const map = new Map<any, string>(
            args[0].flatMap((obj: { [s: string]: unknown; } | ArrayLike<unknown>) =>
                Object.entries(obj).map(([k, v]) => [k !== '' && !isNaN(Number(k)) ? Number(k) : k, v as string])
            )
        );

        return map.get(value);
    }
}

@Pipe({ name: 'boolToImg' })
export class BoolToImgPipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        if (typeof value != 'boolean') {
            throw new Error(`BoolToImgPipe: value ${value} is not valid boolean value`);
        }
        let key = value == true ? 'img_true.png' : 'img_false.png';

        return `<img src="assets/${key}" class="img-bool"></img>`;
    }
}